module.exports = __webpack_public_path__ + "static/img/YORK教室 _3.d4a7262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK教室 _3.png
// module id = c0m4
// module chunks = 0